/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Delete Modal component.
 */
@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteModalComponent {

  /**
   * Show/hide flag.
   * Heading text.
   * ParagraphText text
   * cancel button text
   * delete button text
   */
  @Input() isDeleteModal = false;
  @Input() headingText: string;
  @Input() paragraphText: string;
  @Input() cancelButtonText: string;
  @Input() deleteButtonText: string;

  /**
   * Emit onHide and onDelete event outside.
   */
  @Output() emitOnHidden: EventEmitter<void> = new EventEmitter();
  @Output() emitOnDelete: EventEmitter<void> = new EventEmitter();

  /**
   * Emit onHide event outside.
   */
  onHidden(): void {
    this.isDeleteModal = false;
    this.emitOnHidden.emit();
  }

  /**
   * Emit onDelete event outside.
   */
  onDelete(): void {
    this.emitOnDelete.emit();
  }
}
